import "../index.scss";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setBreadCrumb } from "../../../../middleware/actions/breadCrumbAction";
import { actionSuccess, showLoader, hideLoader, actionError, actionStart, showMessage } from "../../../../middleware/actions/utilityAction";
import { showAlertBox } from "../../../../middleware/actions/alertBoxAction";
import {
  fetchTaxonomyIndustry,
  fetchTaxonomyValueChain,
  saveTaxonomyValueChain,
  updateTaxonomyValueChain,
  deleteTaxonomyValueChain,
  updateTaxonomiesValueChain,
  updateTaxonomyIndustry,
} from "../../../../middleware/services/cmsApi";
import SortableTree from "../../../components/treeView/sortableTree";
import Ascending from "../../../../assets/images/ascending.svg?react";
import Descending from "../../../../assets/images/descending.svg?react";
import Custom from "../../../../assets/images/custom.svg?react";
import SideBar from "./SideBar";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { COMMON_ACCESS_ACTION } from "../../../../constants";
import { accessRightActionCheck } from "../../../../utilities";

const breadCrumbLinks = [];
const ValueChainUI = (props) => {
  const { accessRights: aR } = props;
  const dispatch = useDispatch();

  const [industry, setIndustry] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(undefined);
  const [taxonomy, setTaxonomy] = useState([]);
  const [selectedTaxonomy, setSelectedTaxonomy] = useState(undefined);
  const [show, setShow] = useState(false);
  const [edit, setEdit] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [treeCollapse, setTreeCollapse] = useState(true);
  const [firstRender, setFirstRender] = useState(true);
  const treeSort = [
    { id: 1, value: "ASC" },
    { id: 2, value: "DESC" },
    { id: 3, value: "CUSTOM" },
  ];
  const [sort, setSort] = useState("");
  const [treeSorting, setTreeSorting] = useState("");
  const [allowDragAndDrop, setAllowDragAndDrop] = useState(false);
  const [showAddEdit, setShowAddEdit] = useState(false);
  const [showInstruction, setShowInstruction] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [toggle, setToggle] = useState(true);
  const [changeOrder, setChangeOrder] = useState(false);
  const [industryName, setIndustryName] = useState(undefined);
  const [interfaceActionAccess, setInterfaceActionAccess] = useState([]);

  /* Common access */
  const accessActionAdd = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.ADD);
  const accessActionEdit = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.EDIT);
  const accessActionDelete = interfaceActionAccess.includes(COMMON_ACCESS_ACTION.DELETE);

  const saveUpdatedTaxonomy = async (data) => {
    let result = [];
    data.forEach((item) => {
      let resultObj = {
        id: item.id,
        value_chain_sort_order: item.taxonomySortOrder,
      };
      let childArray = [];

      item?.children &&
        item.children.map((v) => {
          let childObject = {
            tech_id: v.value,
            tech_name: v.label,
            tech_sort_order: v.taxonomySortOrder,
          };
          childArray.push(childObject);
        });
      if (childArray?.length > 0) {
        resultObj.transforming_technologies = childArray;
      }
      result.push(resultObj);
    });
    let params = {
      filters: [],
    };
    params.filters.push(["taxonomyRoot", "eq", selectedIndustry]);
    let payload = {
      taxonomies: result,
    };
    dispatch(showLoader());
    await updateTaxonomiesValueChain(params, payload)
      .then((res) => {
        setChangeOrder(false);
        console.log(industryName, "industrName");
        if (treeSorting != "CUSTOM") fetchTaxonomy(industryName);
        dispatch(actionSuccess("updated successfully"));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        dispatch(actionError("Something went wrong!"));
      });
  };

  /**
   * @description build json for tree
   * @param {Array} data
   */
  const buildTreeJson = (data = []) => {
    return data.map((element) => {
      element["value"] = element.id;
      element["label"] = element.valueChainName;
      element["showCheckbox"] = false;
      element["taxonomySortOrder"] = element.valueChainSortOrder;
      element["level"] = 2;
      element["valueChainDisplayName"] = element.valueChainDisplayName;
      element["trendParentName"] = element.industryName;
      // element["taxonomyParentId"] = element.
      const children = element?.transformingTechnologies ? element?.transformingTechnologies : [];
      if (children.length > 0)
        element["children"] = children.map((tFT) => ({
          value: tFT.techId,
          label: tFT.techName,
          showCheckbox: false,
          id: tFT.techId,
          taxonomySortOrder: tFT.techSortOrder,
          isChild: true,
          parentId: element.id,
          techDisplayName: tFT?.techDisplayName ? tFT?.techDisplayName : "",
          trendParentName: element.valueChainName,
        }));
      return element;
    });
  };

  /**
   * @description fetch taxonomy industry
   */
  const fetchIndustry = () => {
    fetchTaxonomyIndustry({ fields: ["industryName", "industryValueChainSortSeq"], sort: "industryName:asc", limit: 2000 })
      .then((res) => {
        let { data = [] } = res.data;
        setIndustry(data);
        setSelectedIndustry(data[0].id);
        setIndustryName(data[0].industryName);
        fetchTaxonomy(data[0].industryName);
        setTreeSorting(data[0].industryValueChainSortSeq);
        if (data[0]?.industryValueChainSortSeq === "ASC") {
          setSort(1);
        }
        if (data[0]?.industryValueChainSortSeq === "DESC") {
          setSort(2);
        }
        if (data[0]?.industryValueChainSortSeq === "CUSTOM") {
          setSort(3);
        }
      })
      .catch((err) => {
        console.log("err fetchIndustry :: ", err);
      });
  };

  /**
   * @description fetch taxonomy value chain by selected industry name
   * @param {String} industryName
   */
  const fetchTaxonomy = (industryName) => {
    dispatch(showLoader());
    setSelectedTaxonomy(undefined);
    fetchTaxonomyValueChain({
      filters: [["industryName", "eq", industryName]],
      fields: ["valueChainName", "transformingTechnologies", "valueChainSortOrder", "valueChainDisplayName", "industryName"],
      sort: "valueChainSortOrder:asc",
      limit: 2000,
    })
      .then((res) => {
        dispatch(hideLoader());
        let { data = [] } = res.data;
        if (data.length) {
          const treeJosnArray = buildTreeJson(data);
          setTaxonomy(treeJosnArray);
          setTreeCollapse(true);
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
        console.log("err fetchTaxonomy :: ", err);
      });
  };

  /**console.log(
   * @description function to open add new value chain modal
   */
  const openValueChainAddModal = () => {
    if (selectedTaxonomy == undefined || selectedTaxonomy?.length < 2) {
      if (selectedTaxonomy && selectedTaxonomy[0]?.isChild) {
        dispatch(actionError("Can not add node to child node"));
        return true;
      } else {
        setReRender(false);
        setShow(true);
        setShowInstruction(false);
        setShowAddEdit(true);
        setShowAdd(true);
        setEdit(false);
      }
    } else {
      dispatch(showMessage("Please select single node."));
    }
  };

  /**
   * @description function to open edit value chain modal
   */
  const openValueChainEditModal = () => {
    if (selectedTaxonomy?.length == 1) {
      setReRender(false);
      setShow(true);
      setShowInstruction(false);
      setShowAddEdit(true);
      setEdit(true);
      setShowAdd(false);
    } else dispatch(showMessage("Please select single node."));
  };

  /**
   * @description tree node click handler
   * @param {String} dV
   */
  const handleClick = (dV) => {
    if (dV.length > 0) {
      setSelectedTaxonomy(dV);
      setShowAddEdit(true);
      setShowAdd(false);
      setEdit(false);
    } else {
      setSelectedTaxonomy(undefined);
      setShowAddEdit(false);
      setShowInstruction(true);
    }
  };

  /**
   * @description save new value chain
   * @param {String} dtName
   */
  const handleSubmitSaveValueChain = (dtName = undefined, dtDisplayName = undefined) => {
    if (dtName && dtName !== "") {
      if (selectedTaxonomy && selectedTaxonomy?.isChild) {
        dispatch(actionError("Can not add node to child node"));
        return true;
      }
      let payload = {};

      if (selectedTaxonomy) {
        payload.transformingValueChain = {
          transformingValueChainName: dtName,
          valueChainId: selectedTaxonomy[0].value,
        };
        if (dtDisplayName) payload.transformingValueChain["transformingValueChainDisplayName"] = dtDisplayName;
      } else {
        payload.valueChain = {
          valueChainName: dtName,
          industryName: industryName || industry[0].industryName,
        };
        if (dtDisplayName) payload.valueChain["valueChainDisplayName"] = dtDisplayName;
      }
      payload.sortSeq = treeSorting;
      dispatch(actionStart());
      saveTaxonomyValueChain(payload)
        .then((res) => {
          dispatch(actionSuccess("Value chain added successfully"));
          fetchTaxonomy(industryName || industry[0].industryName);
          setShow(true);
          setReRender(true);
          setShowAddEdit(false);
          setShowAdd(false);
          setEdit(false);
          setShowInstruction(true);
        })
        .catch((err) => {
          err?.data?.message ? dispatch(actionError(`${err?.data?.message}`)) : dispatch(actionError("Add value chain failed"));
        });
    }
  };

  /**
   * @description update existing value chain
   * @param {String} dtName
   */
  const handleSubmitUpdateValueChain = (dtName = undefined, dtDisplayName = undefined) => {
    if (dtName && dtName !== "") {
      let payload = {};
      if (selectedTaxonomy && selectedTaxonomy[0]?.isChild) {
        payload.transformingValueChain = {
          transformingValueChainName: dtName,
          transformingValueChainId: selectedTaxonomy[0].value,
        };
        if (dtDisplayName) payload.transformingValueChain["transformingValueChainDisplayName"] = dtDisplayName;
      } else {
        payload.valueChainName = dtName;
        if (dtDisplayName) payload.valueChainDisplayName = dtDisplayName;
      }
      payload.sortSeq = treeSorting;
      dispatch(actionStart());
      updateTaxonomyValueChain(selectedTaxonomy && selectedTaxonomy[0]?.isChild ? selectedTaxonomy[0].parentId : selectedTaxonomy[0].value, payload)
        .then((res) => {
          dispatch(actionSuccess("Value chain updated successfully"));
          fetchTaxonomy(industryName || industry[0].industryName);
          setReRender(true);
          setEdit(false);
          setShowAddEdit(false);
          setShowAdd(false);
          setShowInstruction(true);
        })
        .catch((err) => {
          err?.data?.message ? dispatch(actionError(`${err?.data?.message}`)) : dispatch(actionError("Update value chain failed"));
        });
    }
  };

  /**
   * @description delete value chain
   */
  const deleteTaxonomy = () => {
    let payload = {};

    setTimeout(() => {
      let valueChainIds = [];
      let transformingTechnologyIds = [];
      selectedTaxonomy.map((v) => {
        if (v?.isChild) transformingTechnologyIds.push(v.id);
        else valueChainIds.push(v.id);
      });
      if (valueChainIds?.length) payload["valueChainIds"] = valueChainIds;
      if (transformingTechnologyIds?.length) payload["transformingTechnologyIds"] = transformingTechnologyIds;
      dispatch(actionStart());
      deleteTaxonomyValueChain(payload)
        .then((res) => {
          dispatch(actionSuccess("Value chain deleted successfully"));
          fetchTaxonomy(industryName || industry[0].industryName);
          setReRender(true);
          setEdit(false);
          setShowAddEdit(false);
          setShowAdd(false);
          setShowInstruction(true);
        })
        .catch((err) => {
          let errMsg = err?.data?.message ? err?.data?.message : "Delete value chain failed";
          if (err?.data?.statusCode == 451) {
            let sentence = "";
            let string1 = errMsg.split("--");
            console.log(string1, "string1");
            if (string1[1] != "undefined" && string1[0] != "undefined") {
              let string2 = string1[1].split("-");
              sentence = `Following nodes can not be deleted, nodes are tagged in ${string1[0]}-${string2[1]}`;
            } else {
              if (string1[0] != "undefined") {
                sentence = `Following nodes can not be deleted, nodes are tagged in ${string1[0]}`;
              }
              if (string1[1] != "undefined") {
                sentence = `Following nodes can not be deleted, nodes are tagged in ${string1[1]}`;
              }
            }
            dispatch(actionError(sentence));
          } else {
            dispatch(actionError(errMsg));
          }
        });
    }, 0);
  };

  const handleSequenceTaxonomy = (taxonomyId, payload) => {
    updateTaxonomyIndustry(taxonomyId, payload)
      .then((res) => {
        if (industry?.length) {
          let updated = industry.findIndex((item) => {
            return item.id === taxonomyId;
          });
          industry[updated].industryValueChainSortSeq = payload?.industryValueChainSortSeq;
        }
        dispatch(hideLoader());
      })
      .catch((err) => {
        dispatch(actionError("Update value chain failed"));
        dispatch(hideLoader());
      });
  };

  /**
   * @description function to open delete value chain alert box
   */
  const deleteValueChain = () => {
    if (selectedTaxonomy) {
      setReRender(false);
      dispatch(
        showAlertBox({
          okCallback: deleteTaxonomy,
          okText: "Delete",
          cancelText: "Cancel",
          content: "Do you want to delete value chain ? ",
          title: "dialogAlertCssWarning",
        })
      );
    } else dispatch(actionError("Select Value Chain"));
  };

  useEffect(() => {
    fetchIndustry();
    dispatch(setBreadCrumb(breadCrumbLinks));
    return () => {
      dispatch(setBreadCrumb());
    };
  }, [dispatch]);

  useEffect(() => {
    if (changeOrder) {
      if (treeSorting === "ASC") {
        setSort(1);
      }
      if (treeSorting === "DESC") {
        setSort(2);
      }
      if (treeSorting === "CUSTOM") {
        setSort(3);
      }
    }
  }, [changeOrder]);

  function handleSorting(sortObject) {
    selectedIndustry && handleSequenceTaxonomy(selectedIndustry, { industryValueChainSortSeq: sortObject.value });
    if (sortObject.value === "CUSTOM") {
      setAllowDragAndDrop(true);
    }
  }

  /* Interface actions */
  useEffect(() => {
    const interfaceName = "Listing";
    let actionAccess = accessRightActionCheck(aR.moduleName, interfaceName);
    setInterfaceActionAccess(actionAccess);
  }, []);

  return (
    <div className="pt-2 pb-0" style={{ overflow: "hidden" }}>
      <div className="col-12 bg-white">
        <div className="row taxonomyHeader">
          <div className="col-md-4 pt-2" style={{ minWidth: "250px", maxWidth: "300px" }}>
            {industry.length > 0 ? (
              <DropDownListComponent
                value={selectedIndustry || industry[0].id}
                change={(value) => {
                  setSelectedIndustry(value.value);
                  setIndustryName(value.itemData?.industryName);

                  fetchTaxonomy(value.itemData?.industryName);
                  setTreeSorting(value.itemData?.industryValueChainSortSeq);
                  let typeSort = treeSort.find((item) => {
                    return value?.itemData?.industryValueChainSortSeq === item?.value;
                  });
                  typeSort && setSort(typeSort.id);

                  if (value.industryValueChainSortSeq === "CUSTOM") setAllowDragAndDrop(true);
                }}
                cssClass={"customCss e-outline"}
                floatLabelType="Auto"
                popupHeight="250px"
                dataSource={[...industry]}
                placeholder="Select Industry"
                fields={{ text: "industryName", value: "id" }}
              />
            ) : null}
          </div>
          {treeSorting ? (
            <div className="pt-2 pr-0" style={{ width: "fitContent", display: "inline-block" }}>
              <div className="pt-2">
                <span
                  className="ml-2 ordering"
                  onClick={() => {
                    setTreeSorting("ASC");
                    handleSorting({ id: 1, value: "ASC" });
                    setChangeOrder(true);
                    setAllowDragAndDrop(false);
                  }}
                  style={treeSorting == "ASC" ? { color: "#F94F5E" } : { color: "black" }}
                >
                  <Ascending fill={treeSorting == "ASC" ? "#F94F5E" : "#939399"} />
                  Ascending
                </span>
                <span
                  className="ml-2 ordering"
                  onClick={() => {
                    setTreeSorting("DESC");
                    handleSorting({ id: 2, value: "DESC" });
                    setChangeOrder(true);
                    setAllowDragAndDrop(false);
                  }}
                  style={treeSorting == "DESC" ? { color: "#F94F5E" } : { color: "black" }}
                >
                  <Descending fill={treeSorting == "DESC" ? "#F94F5E" : "#939399"} />
                  Descending
                </span>
                <span
                  className="ml-2 ordering"
                  style={treeSorting == "CUSTOM" ? { color: "#F94F5E" } : { color: "black" }}
                  onClick={() => {
                    setTreeSorting("CUSTOM");
                    handleSorting({ id: 3, value: "CUSTOM" });
                    setChangeOrder(true);
                    setAllowDragAndDrop(true);
                  }}
                >
                  <Custom fill={treeSorting == "CUSTOM" ? "#F94F5E" : "#939399"} />
                  Custom Order
                </span>
              </div>
            </div>
          ) : null}
          <div className="pr-0 pl-0 ml-auto mr-2" style={{ maxWidth: "fitContent" }}>
            <div className="mata-content p-0" style={{ height: "50px", background: "#FAFAFA" }}>
              <ul>
                {accessActionAdd && (
                  <li className="cursor-pointer">
                    <span className="btn btn-primary pr-3 pt-1 pb-1" onClick={() => openValueChainAddModal()}>
                      Add
                    </span>
                  </li>
                )}
                {accessActionEdit && (
                  <li className="cursor-pointer nopointer">
                    <span
                      className={`btn pl-3 pt-1 pb-1  
											 ${selectedTaxonomy ? "taxonomyCustom" : "taxonomyCustomDisable disabled"}`}
                      onClick={() => openValueChainEditModal()}
                    >
                      Edit
                    </span>
                  </li>
                )}
                {accessActionDelete && (
                  <li className="cursor-pointer nopointer">
                    <span
                      className={`btn pl-3 pt-1 pb-1  
											 ${selectedTaxonomy ? "taxonomyCustom" : "disabled taxonomyCustomDisable"}`}
                      onClick={() => deleteValueChain()}
                    >
                      Delete
                    </span>
                  </li>
                )}
                {treeCollapse ? (
                  <li className="cursor-pointer">
                    <span className="btn  pl-3 pt-1 pb-1 taxonomyCustom" onClick={() => setTreeCollapse(false)}>
                      Expand All
                    </span>
                  </li>
                ) : (
                  <li className="cursor-pointer">
                    <span className="btn  pl-3 pt-1 pb-1 taxonomyCustom" onClick={() => setTreeCollapse(true)}>
                      Collapse All
                    </span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row m-0 p-0 bg-white">
        <div className="p-0 pt-3 pl-3 treeScroll">
          {taxonomy.length > 0 ? (
            <div>
              <SortableTree
                treeData={taxonomy}
                onClick={handleClick}
                saveUpdatedTaxonomy={saveUpdatedTaxonomy}
                treeCollapse={treeCollapse}
                sort={treeSorting}
                allowDragAndDrop={allowDragAndDrop}
                setTaxonomy={setTaxonomy}
                selectedMedia={selectedIndustry}
                reRender={reRender}
                setReRender={setReRender}
                firstRender={firstRender}
                flat={true}
                changeOrder={changeOrder}
                parentId={"parentId"}
              />
            </div>
          ) : null}
        </div>
        <div className="ml-auto">
          <div className="taxonomySidebar">
            <span
              className={`${showInstruction ? "invertedText-Color" : "invertedText"}`}
              onClick={() => {
                setToggle(true);
                setShow(true);
                setShowInstruction(true);
                setShowAddEdit(false);
              }}
            >
              {" "}
              Instructions
            </span>
            {showAddEdit && (
              <span
                className={`${showAddEdit ? "invertedText-Color" : "invertedText"}`}
                onClick={() => {
                  setToggle(true);
                  setShow(true);
                  setShowAddEdit(true);
                  setShowInstruction(false);
                }}
              >
                {" "}
                Options
              </span>
            )}
          </div>
        </div>
      </div>

      {showAdd && !showInstruction && (
        <SideBar
          toggle={toggle}
          show={show}
          setShow={setShow}
          showAddEdit={showAddEdit}
          handleSubmit={handleSubmitSaveValueChain}
          selectedNode={selectedTaxonomy}
          setShowAddEdit={setShowAddEdit}
          setShowInstruction={setShowInstruction}
        />
      )}

      {edit && !showInstruction && (
        <SideBar
          toggle={toggle}
          show={show}
          setShow={setShow}
          showAddEdit={showAddEdit}
          selectedTaxonomy={selectedTaxonomy}
          handleSubmit={handleSubmitUpdateValueChain}
          selectedNode={selectedTaxonomy}
          setShowAddEdit={setShowAddEdit}
          setShowInstruction={setShowInstruction}
        />
      )}

      {showInstruction && (
        <SideBar
          toggle={toggle}
          show={show}
          setShow={setShow}
          showInstruction={showInstruction}
          setShowAddEdit={setShowAddEdit}
          setShowInstruction={setShowInstruction}
        />
      )}
    </div>
  );
};

export default ValueChainUI;
